import { Component, inject } from "@angular/core";
import { UiKitModule } from "@app/ui-kit.module";
import { AddButtonComponent } from "@components/add-button/add-button.component";
import { ToggleItemTextVisibilityButtonComponent } from "@components/toggle-item-text-visibility-button/toggle-item-text-visibility-button.component";
import { ToggleLockButtonComponent } from "@components/toggle-lock-button/toggle-lock-button.component";
import { ToggleVisibilityButtonComponent } from "@components/toggle-visibility-button/toggle-visibility-button.component";
import { FloorplanState } from "@domain/project/floorplan/floorplan-state";
import { FloorplanMenuItemButtonsComponent } from "@project/floorplanner/floorplan-menu/fgds/floorplan-menu-item-buttons/floorplan-menu-item-buttons.component";
import { FloorplanService } from "@project/floorplanner/floorplan.service";
import { DraggedItemType, FloorplanDragDropService } from "@utils/floorplan-drag-drop.service";

@Component({
  selector: "app-floorplan-free-text-menu",
  imports: [
    UiKitModule,
    FloorplanMenuItemButtonsComponent,
    AddButtonComponent,
    ToggleVisibilityButtonComponent,
    ToggleLockButtonComponent,
    ToggleItemTextVisibilityButtonComponent,
  ],
  templateUrl: "./floorplan-free-text-menu.component.html",
  styleUrl: "./floorplan-free-text-menu.component.scss",
})
export class FloorplanFreeTextMenuComponent {
  private readonly floorplanService = inject(FloorplanService);
  private readonly dragDropService = inject(FloorplanDragDropService);

  protected readonly floorplanState: FloorplanState;

  protected readonly tooltipTextAddFreeText = $localize`:@@floorplan.button.addFreeText:Neues Freitextfeld hinzufügen`;
  protected readonly freeTextPlaceholder = $localize`:@@floorplan.details.freeText.placeholder:Freitext`;

  constructor() {
    this.floorplanState = this.floorplanService.selectedFloorplan.floorplanState;
  }

  protected addFreeText(): void {
    this.floorplanService.addFreeText(this.freeTextPlaceholder);
  }

  protected dragFreeText(): void {
    this.dragDropService.setDragged({ type: DraggedItemType.FREE_TEXT, freeTextPlaceholder: this.freeTextPlaceholder });
  }

  protected updateFreeTextsItemTextVisibility(visible: boolean): void {
    this.floorplanState.updateFloorplanFreeTextsItemTextVisibility(visible);
  }
}
